import {IChannel, ITraveller, TripType} from '../../../../data/api/models';

const clearDestinations = (dispatch, change) => {
    dispatch(change('destinations', ''));
};

const setAnnualMaxTripDuration = (channel: IChannel, dispatch, change, travellers, region) => {
    dispatch(change('maxTripDuration', 45));

    if (channel.key === 'tpl-b2c') {
        dispatch(change('maxTripDuration', 33));
    } else {
        dispatch(change('maxTripDuration', 45));
    }
    if (channel.key === 'csis-b2c') {
        // let maxTripDuration = 65;

        // if (region === 'worldwide' || region === 'worldwide_excluding') {
        //     maxTripDuration = 45;
        // } else {
        //     let maxAge = 0;
        //
        //     travellers.forEach((traveller) => {
        //         const age = this.getAge(traveller.dob);
        //         if (age > maxAge) {
        //             maxAge = age;
        //         }
        //     });
        //
        //     if (maxAge > 69) {
        //         maxTripDuration = 45;
        //     }
        // }

        // dispatch(change('maxTripDuration', maxTripDuration));
    }
};

export const setMaxTripDuration = (
    tripType: TripType,
    channel: IChannel,
    travellers: ITraveller[],
    dispatch,
    change,
    region,
) => {
    if (tripType === 'annual') {
        clearDestinations(dispatch, change);
        setAnnualMaxTripDuration(channel, dispatch, change, travellers, region);
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetailsJourneyB/tripJourney.helpers.ts